import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProfilesComponent } from './profiles.component';
import { AuthorizationModule } from '../../modules/authorization/authorization.module';
import { RoleValidScopeComponent } from './components/role-valid-scope/role-valid-scope.component';
import { TableModule } from '../../lib';
import { SharedModule } from '../../modules/shared/shared.module';
import { RoleConfigComponent } from './components/role-config/role-config.component';
import { MaterialModule } from '../../modules/material/material.module';
import { CapitalizeFirstPipe } from '../capitalize-first.pipe';
import { SharedModule as libSharedModule } from 'shared-library';

const routes: Routes = [
  { path: '', pathMatch: "full", component: ProfilesComponent },
  { path: 'config', pathMatch: "full", component: RoleConfigComponent}
]


@NgModule({
  declarations: [
    ProfilesComponent,
    RoleValidScopeComponent,
    RoleConfigComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    AuthorizationModule,
    RouterModule.forChild(routes),
    MaterialModule,
    CapitalizeFirstPipe,
    libSharedModule
  ]

})
export class ProfilesModule { }
